import React, { Component } from 'react';
import {
  CreateTournament,
  CreateScheduleItem,
  GetCompetition,
  ListTeams,
  ListScheduleItems
} from './graphql.js';
import { updateInPath, nullsToStrings } from '../../../../common/utils';
import { getList, getItem, setItem } from '../../../common/utils';
import { clone, map, addIndex } from 'ramda';
import { generateScheduleWithMeta } from '../../utils/scheduler';
import CompetitionFilter from '../../components/competitionFilter';
import { Tournament, ScheduleTab } from '../../../common/components/Tournament';
import { Dimmer, Loader, Segment } from 'semantic-ui-react';


const ixMap = addIndex(map);

const BLANK = {
  competitionId: '',
  beginTime: '',
  timeOffsetInMinutes: 0,
  lunchBeginTime: '',
  lunchEndTime: '',
  area: '',
  sector: '',
  i18n_comments: '{}'
};

// END config
export default class Teams extends Component {
  constructor() {
    super();

    this.state = {
      competitions: [],
      loading: false,
      competition: {},
      tournament: clone(BLANK),
      calc: {},
      matches: [],
      scheduleSaveProgess: null
    };
    this.filter = {};
  }

  handleTournamentChange = (e, { name, value }) => {
    this.setState(s => updateInPath(s, 'tournament.' + name, value));
  }

  // TODO reset data or update tournament!
  handleTournamentSave = async () => {
    const tournament = clone(this.state.tournament);
    delete tournament.hasMatches;

    this.setState(s => updateInPath(s, 'loading', true));
    const { createTournament: data } = await setItem(CreateTournament, tournament);
    this.setState(s => updateInPath(s, 'tournament', nullsToStrings(data)));
    this.setState(s => updateInPath(s, 'loading', false));
  }

  handleMatchSave = async (data, ix, l) => {
    const d = clone(data),
          p = ix + 1 === l ? null : Math.ceil((ix + 1) / l * 100);
    delete d.team;
    const { createScheduleItem } = await setItem(CreateScheduleItem, d);

    console.log( createScheduleItem );
    console.log( p );
    this.setState(s => updateInPath(s, 'scheduleSaveProgess', p));
  }

  handleCreateMatches = () => {
    const schedule = this.state.calc.schedule,
          l = schedule.length;

    console.log( 'Items to save:' + l );

    ixMap((match, ix) => {

      window.setTimeout(() => {
        this.handleMatchSave(match, ix, l);
      }, 100 * ix);
      
    }, schedule || []);
    this.setState(s => updateInPath(s, 'calc', {}));
    this.setState(s => updateInPath(s, 'matches', schedule));
    this.setState(s => updateInPath(s, 'tournament.hasMatches', true));
  }

  handleCompetitionSelect = async ({ competitionId : { eq: cId }}, eventId) => {
    this.setState(s => updateInPath(s, 'competitionId', cId));
    this.setState(s => updateInPath(s, 'eventId', eventId));
    this.setState(s => updateInPath(s, 'loading', true));

    const c = await getItem('getCompetition', {
      query: GetCompetition,
      variables: {
        eventId: eventId,
        competitionId: cId
      }
    });
    //c.tournament.hasMatches = false;
    this.setState(s => updateInPath(s, 'competition', c || {}));

    const t = c.tournament || clone(BLANK);
    
    t.competitionId = cId;
    this.setState(s => updateInPath(s, 'tournament', nullsToStrings(t)));
    

    if (c && c.tournament && c.tournament.hasMatches) {
      const m = await getList('listScheduleItems', {
        query: ListScheduleItems,
        variables: { competitionId: cId }
      });

      this.setState(s => updateInPath(s, 'matches', m || []));
    }

    this.setState(s => updateInPath(s, 'calc', {}));
    this.setState(s => updateInPath(s, 'loading', false));
  }

  handleProposeSchedule = async () => {
    const c = this.state.competition,
          t = this.state.tournament;
    
    this.setState(s => updateInPath(s, 'loading', true));
    const teams = await getList('listTeams', {
      query: ListTeams,
      variables: { filter: { competitionId: { eq: c.competitionId }}, limit: 200 }
    }, ['i18n_title']);

    const calc = generateScheduleWithMeta(teams, c, t);
    this.setState(s => updateInPath(s, 'calc', calc));
    this.setState(s => updateInPath(s, 'loading', false));
  }
  

  render() {
    const {
      loading,
      competition,
      tournament,
      calc,
      matches,
      scheduleSaveProgess
    } = this.state;

    const cId = competition.competitionId,
          genBtnTitle = 'Generate schedule (' + competition.competitionType + ')';

    //console.log(calc.schedule);
    
    return (
      <div>
        <Dimmer inverted active={!!scheduleSaveProgess}>
          <Loader inverted content='Generating matches. Do not refresh the page!'/>
        </Dimmer>
        <CompetitionFilter
          disabled={loading}
          textParam='competitionType'
          onSubmit={this.handleCompetitionSelect}/>
        { cId && <Tournament
                   loading={loading}
                   data={tournament}
                   hasGeneratedSchedule={!!(calc.schedule && calc.schedule.length)}
                   onChange={this.handleTournamentChange}
                   onSubmit={this.handleTournamentSave}
                   generateScheduleBtnTitle={genBtnTitle}
                   onScheduleGenerate={this.handleProposeSchedule}
                   onScheduleSave={this.handleCreateMatches}
                   scheduleSaveProgess={scheduleSaveProgess}/> }
        { cId && <div>
                   {calc.meta && <Segment basic>
                                   Debug:
                                   Teams before payment filter: {calc.meta.teamsCount},
                                   Teams not paid: {calc.meta.teamsNotPaid},
                                   Teams in schedule {calc.meta.teamsInSchedule},
                                 </Segment>}
                   {!matches.length && <ScheduleTab
                                         isAdmin={true}
                                         data={calc.schedule}
                                         competition={competition}
                                         noDataText='Click on `generate schedule` button!'
                                         loading={loading}
                                         title='Proposed Schedule'/>}
                   <ScheduleTab
                     isAdmin={true}
                     data={matches}
                     competition={competition}
                     noDataText='This competition does not have a schedule yet!'
                     loading={loading}
                     title='Competition Schedule'/>
                 </div>}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/private/admin/containers/Tournaments/index.js